import { TContentDomain } from '@/types/Content.types';
import { Box, HStack, Image, Text } from '@chakra-ui/react';
import { DOMAIN_LABEL } from './contentLabels';

// Domain header (purple icon tile + label), mirroring the creator/peer-support UI.
const DomainSectionLabel = ({ domain }: { domain: TContentDomain }) => (
  <HStack justifyContent="flex-start" width="100%" gap="10px">
    <Box backgroundColor="background.lightPurple" padding="3px" borderRadius="4px">
      <Image src={`/img/png/icons/wellness-domains-purple/${domain}.png`} width="16px" height="16px" alt={DOMAIN_LABEL[domain]} />
    </Box>
    <Text fontSize="12px" fontWeight={800} color="primary.500" textTransform="uppercase" letterSpacing="0.3px">
      {DOMAIN_LABEL[domain]}
    </Text>
  </HStack>
);

export default DomainSectionLabel;
